export default __webpack_public_path__ + "static/media/el14.844dbb71.svg";